exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sub[data-v-8df50ede]{margin-top:30px;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-8df50ede","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/gestionDesAbsences/modals/modalDetailAbsence/modalDetailAbsence.scss
// module id = Jie8
// module chunks = 2